import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from 'react-redux'

// react-bootstrap components
import {
    Badge,
    Button,
    ButtonGroup,
    Card,
    Collapse,
    Form,
    InputGroup,
    Navbar,
    Nav,
    Pagination,
    Container,
    Row,
    Col,
    Dropdown
} from "react-bootstrap";
import operationalPath from 'assets/files/application-for-employment-operational.pdf';
import monitoringPath from 'assets/files/equal-opportunities-monitoring-form.pdf';
import staffPath from 'assets/files/application-for-employment-staff.pdf';
function Sidebar({ routes, image, background }) {


    const onDownloadApplication = (jobType, e) => {
        e.preventDefault();

        const url = jobType === "Staff"
            ? staffPath
            : operationalPath

        fetch(url).then(response => {
            response.blob().then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'FPM Application Form.pdf';
                alink.click();
            });
        });
    };


    const onDownloadMonitoring = (e) => {
        e.preventDefault();

        fetch(monitoringPath).then(response => {
            response.blob().then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'FPM - Equal Opportunities Monitoring Form.pdf';
                alink.click();
            });
        });
    };

    const dispatch = useDispatch()
    const isFavourites = useSelector((state) => state.isFavourites);
    const isSideBarMini = useSelector((state) => state.isSideBarMini);

    // to check for active links and opened collapses
    let location = useLocation();
    // this is for the user collapse
    const [userCollapseState, setUserCollapseState] = React.useState(false);
    // this is for the rest of the collapses
    const [state, setState] = React.useState({});
    React.useEffect(() => {
        setState(getCollapseStates(routes));
    }, []);
    // this creates the intial state of this component based on the collapse routes
    // that it gets through routes prop
    const getCollapseStates = (routes) => {
        let initialState = {};
        routes.map((prop, key) => {
            if (prop.collapse) {
                initialState = {
                    [prop.state]: getCollapseInitialState(prop.views),
                    ...getCollapseStates(prop.views),
                    ...initialState,
                };
            }
            return null;
        });
        return initialState;
    };
    // this verifies if any of the collapses should be default opened on a rerender of this component
    // for example, on the refresh of the page,
    // while on the src/views/forms/RegularForms.jsx - route /admin/regular-forms
    const getCollapseInitialState = (routes) => {
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
                return true;
            } else if (location.pathname === routes[i].layout + routes[i].path) {
                return true;
            }
        }
        return false;
    };
    // this function creates the links and collapses that appear in the sidebar (left menu)
    const createLinks = (routes) => {
        return routes.map((prop, key) => {
            if (prop.redirect) {
                return null;
            }
            if (!prop.path.includes("populi") && prop.collapse) {
                var st = {};
                st[prop["state"]] = !state[prop.state];
                return (
                    <Nav.Item
                        className={getCollapseInitialState(prop.views) ? "active" : ""}
                        as="li"
                        key={key}
                    >
                        <Nav.Link
                            className={state[prop.state] ? "collapsed" : ""}
                            data-toggle="collapse"
                            onClick={(e) => {
                                e.preventDefault();
                                setState({ ...state, ...st });
                            }}
                            aria-expanded={state[prop.state]}
                        >
                            <i className={prop.icon}></i>
                            <p>
                                {prop.name} <b className="caret"></b>
                            </p>
                        </Nav.Link>
                        <Collapse in={state[prop.state]}>
                            <div>
                                <Nav as="ul">{createLinks(prop.views)}</Nav>
                            </div>
                        </Collapse>
                    </Nav.Item>
                );
            }
            return (
                <>
                    {!prop.path.includes("populi") &&
                        <Nav.Item
                            className={activeRoute(prop.layout + prop.path)}
                            key={key}
                            as="li"
                        >
                            <Nav.Link to={prop.path} as={Link}>
                                {prop.icon ? (
                                    <>
                                        <i className={prop.icon} />
                                        <p>{prop.name}</p>
                                    </>
                                ) : (
                                    <>
                                        <span className="sidebar-mini">{prop.mini}</span>
                                        <span className="sidebar-normal">{prop.name}</span>
                                    </>
                                )}
                            </Nav.Link>
                        </Nav.Item>
                    }
                </>
            );
        });
    };
    // verifies if routeName is the one active (in browser input)
    const activeRoute = (routeName) => {
        return location.pathname === routeName ? "active" : "";
    };

    const [open, setOpen] = useState(false);

    const toggleDropdown = () => {
        setOpen(!open);
    };

    return (
        <>
            <div className="sidebar fpm-sidebar" data-color={background} data-image={image}>
                <div className="sidebar-wrapper">
                    <div className="logo">
                        <div className="logo-img">
                            <img
                                src={require("assets/img/logo.png").default}
                                alt="fpmccann-logo"
                            />
                        </div>
                    </div>

                    <Nav as="ul">

                        {createLinks(routes)}

                   
                        <Nav.Item as="li" className={open ? 'open' : ''}>
                            <Nav.Link onClick={toggleDropdown} style={{ display: 'flex', alignItems: 'center' }}>
                                <i className="fa">&#xf019;</i> Forms
                                <span
                                    className="dropdown-icon"
                                    style={{
                                        marginLeft: '5px', 
                                        transform: open ?? 'rotate(360deg)' 
                                    }}
                                >
                                    {open ? <i className="fa fa-caret-up"></i> : <i className="fa fa-caret-down"></i>}
                                </span>
                            </Nav.Link>

                            <Collapse in={open}>
                                <div style={{ textAlign: 'center' , fontSize: '15px'}}>

                                    <div style={{ marginBottom: '12px' }}>
                                        <a
                                            href="#"
                                            className="downloadlink"
                                            rel="noopener noreferrer"
                                            style={{ textAlign: "start" }}
                                            onClick={(e) => onDownloadApplication("Staff",e)}
                                        >
                                            Application Form (Staff)
                                        </a>
                                    </div>
                                    <div style={{ marginBottom: '12px' }}>
                                        <a
                                            href="#"
                                            className="downloadlink"
                                            rel="noopener noreferrer"
                                            style={{ textAlign: "start" }}
                                            onClick={(e) => onDownloadApplication("Operational", e)}
                                        >
                                            Application Form (Operational)
                                        </a>
                                    </div>
                               
                                    <div>
                                        <a
                                            href="#"
                                            className="downloadlink"
                                            rel="noopener noreferrer"
                                            style={{ textAlign: "start" }}
                                            onClick={(e) => onDownloadMonitoring(e)}
                                        >
                                            Monitoring Questionnaire
                                        </a>
                                    </div>
                                </div>
                            </Collapse>
                        </Nav.Item>
                    </Nav>
                </div>
                <div
                    className="sidebar-background"
                    style={{
                        backgroundImage: "url('" + image + "')",
                    }}
                ></div>
            </div>
        </>
    );
}

let linkPropTypes = {
    path: PropTypes.string,
    layout: PropTypes.string,
    name: PropTypes.string,
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
};

Sidebar.defaultProps = {
    image: "",
    background: "fpm-dark-blue",
    routes: [],
};

Sidebar.propTypes = {
    image: PropTypes.string,
    background: PropTypes.oneOf([
        "fpm-dark-blue",
        "black",
        "azure",
        "green",
        "orange",
        "red",
        "purple",
    ]),
    routes: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.shape({
                ...linkPropTypes,
                icon: PropTypes.string,
            }),
            PropTypes.shape({
                collapse: true,
                path: PropTypes.string,
                name: PropTypes.string,
                state: PropTypes.string,
                icon: PropTypes.string,
                views: PropTypes.shape({
                    ...linkPropTypes,
                    mini: PropTypes.string,
                }),
            }),
        ])
    ),
};

export default Sidebar;
